import { SELECTED_TAB_KEY } from "../../../../../constants/Constants";
import { t } from "i18next"

export const tabDetails = (selectedValue) =>{ 
  
    return [
      {
        id: SELECTED_TAB_KEY.UPLOADSTUDY+"1",
        title: t("upload-study.dicom"),
        contentClass: "tabContent",
      },
      {
        id: SELECTED_TAB_KEY.UPLOADSTUDY+"2",
        title: t("upload-study.image"),
        contentClass: "tabContent",
      }
]};